
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/engage/[client]/agendas",
      function () {
        return require("private-next-pages/engage/[client]/agendas.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/engage/[client]/agendas"])
      });
    }
  